/**
 * Extract values for array typed filters from url in v1 format.
 * The v1 format is as follow:
 * filters=name_value1-1,name_value1-2,name_value1-3&filters=name_value2
 *
 * @param filterStrings An array of string containing all values associated to the `filters` search param. (array of string with the format `name_value`)
 * @param filterName The name of the filter you want to extract.
 * @returns
 */
export const extractArrayFilterV1Values = (filterStrings: string[], filterName: string) =>
    filterStrings.reduce((acc: string[], filter) => {
        if (filter.startsWith(`${filterName}_`)) {
            const parts = filter.split('_');
            const values = parts[parts.length - 1].split(',');
            return acc.concat(values);
        }
        return acc;
    }, []);
